
  import { Component, Vue } from 'vue-property-decorator'
  // @ts-ignore
  import packageJson from '../../package.json'
  import { About } from '@parantion/components'

  @Component({
    components: {
      About
    }
  })
  export default class AboutPage extends Vue {
    tenantName: string = packageJson.name

    get view() {
      const desktop = 'q-pt-lg q-pl-xl q-pr-lg q-pb-lg'
      const mobile = 'q-ma-md'
      return this.$q.platform.is.desktop ? desktop : mobile
    }
  }
